var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericCard',{attrs:{"size":"auto"}},[_c('OutstandingListCore',{attrs:{"onlyPastDue":true},on:{"finishLoading":function($event){return _vm.$emit("finishLoading", $event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }